import { UploadStatus } from '@/types/aeroUpload/aeroUpload'

/** アップロード状態 表示ラベル定義 */
export const UploadStatusLabel: Record<UploadStatus, string> = {
  [UploadStatus.WAIT]: 'アップロード開始待ち',
  [UploadStatus.WAITING_UPLOAD]: 'アップロード処理待ち',
  [UploadStatus.UPLOADING]: 'アップロード中（{0}%）',
  [UploadStatus.COMPLETE]: '成功',
  [UploadStatus.ERROR]: '失敗'
}
